<template>
  <!-- 会员卡管理-用户列表 -->
  <div class="vip_user-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model.trim="query.user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="query.card_id"
            placeholder="请选择状态"
            @change="getData(1)"
          >
            <el-option :value="0" label="全部"></el-option>
            <el-option
              v-for="item in cardList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="query.status"
            placeholder="请选择卡名"
            @change="getData(1)"
          >
            <el-option :value="0" label="全部"></el-option>
            <el-option :value="1" label="生效中"></el-option>
            <el-option :value="2" label="已删除"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="user_id" label="用户id" align="center">
        </el-table-column>
        <el-table-column label="用户名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.user && row.user.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="会员卡" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.member_card && row.member_card.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="!row.deleted_at">生效中</el-tag>
            <el-tag type="info" v-if="row.deleted_at">已删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="300px"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button
              type="danger"
              size="small"
              @click="deleteEvent(row)"
              v-if="!row.deleted_at"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        class="underBar"
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page || 1"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'

export default {
  name: 'vip_user',
  components: {
  },
  data() {
    return {
      detailsVisible: false,//用户详情信息显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
        user_id: undefined,//用户id
        card_id: 0,//卡片id
        status: 0,//状态
      },
      cardList: undefined,//卡片名称列表
      dialogInfo: undefined,//要传递的弹窗数据
      dataList: undefined,//列表数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
    !this.cardList && this.getCardName()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('member_card_user', params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = {
            current_page: res.current_page,//当前页标
            per_page: res.per_page,//每页多少条
            total: res.total,//总数据条数
            total_pages: res.total_pages,//总页数
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getCardName() {
      //获取会员卡列表
      getApiData('member_card').then(res => {
        this.cardList = res.data
      })
    },
    deleteEvent(rowInfo) {
      //删除
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`member_card_user/${rowInfo.id}`).then((res) => {
          if (res.code) {
            this.$message.success(res.message)
            this.getData()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
    handleExport() {
      let params = this.query
      http
        .post(
          api + 'member_card_user_export', params,
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '会员用户表.xlsx'
          })
        })
    },
  },
}
</script>

<style lang="less" scoped>
.vip_user-box {
  header {
  }

  .body-box {
  }
}
</style>